import { Spin } from "antd";
import SVGIcon from "../../constants/SVGIcon";
import styles from "./statistics-card.module.css";

const StatisticsCard = ({
  icon_name,
  icon_fill,
  icon_stroke,
  icon_width,
  icon_height,
  heading_text,
  card_bg_color,
  icon_container_bg_color,
  statistic_value,
  loading = false,
}) => {
  const styles_from_props = {
    main_card: { backgroundColor: card_bg_color },
    icon_container: { backgroundColor: icon_container_bg_color },
  };
  return (
    <div className={styles.statistics_card} style={styles_from_props.main_card}>
      <div className={styles.statistics_card_top}>
        <div
          className={styles.statistics_card_top_icon_container}
          style={styles_from_props.icon_container}
        >
          <SVGIcon
            name={icon_name}
            width={icon_width}
            height={icon_height}
            fill={icon_fill}
            stroke={icon_stroke}
          />
        </div>
        <div className={styles.statistics_card_statistic_value_container}>
          {loading || statistic_value === "-" ? <Spin /> : statistic_value}
        </div>
      </div>
      <div className={styles.statistics_card_bottom}>
        <h3 className={styles.statistics_card_bottom_heading}>
          {heading_text}
        </h3>
      </div>
    </div>
  );
};

export default StatisticsCard;
